import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ConsultAbout() {
  const navigate = useNavigate();

  return (
    <div className="sec-wrapper">
      {/* Unified Vivah Nepal Hero Banner */}
      <section className="hero-section">
        <div className="hero-content">
          <div style={{ marginBottom: '1.2rem' }}>
            <span className="badge-hero-top">
              ✦ TRUSTED NEPALESE MARRIAGE CONSULTANT ✦
            </span>
          </div>

          <h1 className="hero-title">
            About Consultant <span className="hero-title-gradient">Laxmikant Timilsina</span>
          </h1>

          <p className="hero-subtitle">
            Providing authentic, traditional, and Kundali-matched matrimonial consultation. Resident of <strong>Tansen-09, Palpa</strong> and operating from main office at <strong>Yogikuti Chowk, Butwal-10, Nepal</strong>.
          </p>

          <div className="hero-cta-group">
            <a href="tel:9857074103" className="btn btn-secondary">
              📞 Call Laxmikant (9857074103) →
            </a>
            <button className="btn btn-tertiary" onClick={() => navigate('/consultation/register')}>
              💍 Register Profile →
            </button>
          </div>
        </div>
      </section>

      {/* Host Profile Card */}
      <div className="card" style={{ marginBottom: '3rem', border: '1.5px solid #D4AF37' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem', alignItems: 'center' }}>
          <div>
            <div style={{ display: 'flex', gap: '0.6rem', alignItems: 'center', marginBottom: '0.8rem', flexWrap: 'wrap' }}>
              <span className="badge-verified">✓ Official Matrimonial Consultant</span>
              <span className="badge-light">10+ Years Experience</span>
            </div>
            <h2 style={{ fontFamily: 'var(--serif)', fontSize: '2.2rem', fontWeight: 700, color: '#9E1B32', marginBottom: '0.4rem' }}>
              Laxmikant Timilsina
            </h2>
            <div style={{ fontSize: '0.9rem', color: '#8C6A23', fontWeight: 700, marginBottom: '1rem' }}>
              📍 Resident of Tansen-09, Palpa | Office: Yogikuti, Butwal
            </div>
            <p style={{ fontSize: '0.9rem', color: '#6E615E', lineHeight: 1.7, marginBottom: '1.4rem' }}>
              For over a decade, Laxmikant Timilsina has guided hundreds of Nepalese families through traditional matchmaking. By combining cultural values, Gotra compatibility, and horoscope (Kundali) evaluation with modern privacy protection, we ensure that finding your life partner is a safe, dignified, and joyous journey.
            </p>
            <div style={{ display: 'flex', gap: '0.8rem', flexWrap: 'wrap' }}>
              <a href="tel:9857074103" className="btn btn-primary">
                📞 Call Laxmikant: 9857074103
              </a>
              <button className="btn btn-secondary" onClick={() => navigate('/consultation/payment')}>
                📲 Membership &amp; QR Payment
              </button>
            </div>
          </div>

          <div style={{
            background: 'linear-gradient(135deg, #1C1014 0%, #28171C 100%)',
            borderRadius: '20px',
            padding: '2rem',
            color: '#F7D070',
            border: '1.5px solid #D4AF37',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>🙏</div>
            <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.6rem', color: '#fff', marginBottom: '0.8rem' }}>
              Our 4 Core Pillars
            </h3>
            <ul style={{ listStyle: 'none', textAlign: 'left', fontSize: '0.88rem', lineHeight: 2, color: 'rgba(255,255,255,0.9)' }}>
              <li>✓ 100% Confidential Profile Handling</li>
              <li>✓ Verified Identity & Family Check</li>
              <li>✓ Traditional Kundali & Gotra Match</li>
              <li>✓ Direct Family Facilitation</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Office & Operations Card */}
      <div className="card" style={{ border: '1.5px solid #E8DFD1' }}>
        <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.7rem', fontWeight: 700, color: '#9E1B32', marginBottom: '0.8rem' }}>
          Matrimony & Partnered Event Services
        </h3>
        <p style={{ fontSize: '0.9rem', color: '#6E615E', lineHeight: 1.7, marginBottom: '1.4rem' }}>
          In addition to matrimonial consultation, Laxmikant Timilsina partners with <strong>Krishna Khanal</strong> (also resident of Tansen-09, Palpa) to operate <strong>Sabitri Catering and Tent House</strong> from their main office at <strong>Yogikuti Chowk, Butwal-10, Nepal</strong>.
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: '1.2rem',
          background: '#FAF6ED',
          padding: '1.4rem',
          borderRadius: '16px',
          border: '1px solid #E8DFD1'
        }}>
          <div>
            <div style={{ fontSize: '0.72rem', textTransform: 'uppercase', color: '#8C6A23', fontWeight: 800, letterSpacing: '0.05em' }}>
              CONSULTANT RESIDENCE
            </div>
            <div style={{ fontSize: '0.95rem', fontWeight: 700, color: '#1C1014', marginTop: '0.2rem' }}>
              Tansen-09, Palpa, Nepal
            </div>
            <div style={{ fontSize: '0.84rem', color: '#6E615E', marginTop: '0.1rem' }}>Contact: 9857074103</div>
          </div>

          <div>
            <div style={{ fontSize: '0.72rem', textTransform: 'uppercase', color: '#8C6A23', fontWeight: 800, letterSpacing: '0.05em' }}>
              MAIN CORPORATE OFFICE
            </div>
            <div style={{ fontSize: '0.95rem', fontWeight: 700, color: '#1C1014', marginTop: '0.2rem' }}>
              Yogikuti Chowk, Butwal-10, Nepal
            </div>
            <div style={{ fontSize: '0.84rem', color: '#6E615E', marginTop: '0.1rem' }}>Sabitri Catering & Tent House (9867155395)</div>
          </div>
        </div>
      </div>
    </div>
  );
}